module.exports = __webpack_public_path__ + "static/img/step03.26f8fb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step03.png
// module id = OL0v
// module chunks = 1